export class ProblemPackageOpenError extends Error {
  constructor(m: string) {
    super(m);
    this.name = "ProblemPackageOpenError";
  }
}
